module.exports = __webpack_public_path__ + "img/ppsea_logo.3af3f04a.png";